export const environment = {
  production: true,
  apiUrl: 'https://portaal.heutinck.eu/api'
};
